import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
function track(name: string, value: number) {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: name,
    value,
    currency: 'USD'
  });
}
const includes = ['Todo lo del Mega Pack Historia 360 (8 tomos + 4 bonos)', 'Mesopotamia y el nacimiento de la civilización — profundidad real', 'Egipto, India, China y pueblos del Mediterráneo oriental', 'Grecia antigua y Roma — desde la polis hasta la caída del Imperio', 'Edad Media, Renacimiento y Reforma religiosa', 'Ilustración, Revoluciones atlánticas e Industrialización', 'Imperialismo y caja final de herramientas docentes avanzadas'];
export function PricingSection() {
  return <section id="pricing" className="relative bg-black px-4 py-20" data-id="element-130">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-96 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[110px]" data-id="element-131" />
      <div className="relative mx-auto max-w-3xl" data-id="element-132">
        <header className="mb-12 text-center" data-id="element-133">
          <h2 className="font-serif text-4xl font-bold" data-id="element-134">Elige tu pack</h2>
          <p className="mt-2 text-gold-light" data-id="element-135">
            Dos opciones · Mismo acceso inmediato
          </p>
        </header>

        <PriceCard label="OFERTA PRINCIPAL" name="Mega Pack Historia 360" desc="Los 8 tomos + 4 bonos estratégicos listos para usar en el aula." old="USD 55,00" price="USD 19,90" url="https://ktdgr0-mw.myshopify.com/cart/48182459236570:1" value={19.9} data-id="element-136" />

        <motion.article initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mt-9 rounded-3xl border-2 border-gold bg-dark-card p-1 shadow-[0_0_45px_rgba(212,175,55,.18)]" data-id="element-137">
          <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-gold-gradient px-5 py-1.5 text-xs font-bold text-black" data-id="element-138">
            <Sparkles size={13} data-id="element-139" /> MÁS ELEGIDO · MEJOR VALOR
          </div>

          <div className="rounded-[1.3rem] bg-black p-7 text-center sm:p-10" data-id="element-140">
            <h3 className="font-serif text-2xl font-bold text-gold-gradient" data-id="element-141">
              Mega Pack Historia 360 + Pack Maestro Avanzado
            </h3>
            <p className="my-4 text-gray-300" data-id="element-142">
              El pack completo más material que profundiza los períodos más
              enseñados en el aula.
            </p>

            <ul className="mx-auto mb-6 max-w-md space-y-2 rounded-xl border border-gold/20 bg-gold/5 p-4 text-left" data-id="element-143">
              {includes.map(item => <li className="flex gap-2 text-sm text-gray-200" key={item} data-id="element-144">
                  <Check size={16} className="shrink-0 text-gold" data-id="element-145" />
                  {item}
                </li>)}
            </ul>

            <s className="block text-gray-500" data-id="element-146">USD 82,90</s>
            <p className="my-2 text-4xl font-bold text-gold" data-id="element-147">USD 27,90</p>

            <Button target="_blank" href="https://ktdgr0-mw.myshopify.com/cart/48182509175002:1" onLinkClick={() => track('Mega Pack Historia 360 + Pack Maestro Avanzado', 27.9)} className="mt-3 w-full sm:w-auto" data-id="element-148">
              LLEVAR EL PACK COMPLETO
            </Button>

            <p className="mt-5 flex items-start gap-2 rounded-xl border border-white/10 bg-white/5 p-3 text-left text-xs text-gray-400" data-id="element-149">
              <Globe size={15} className="shrink-0 text-gold" data-id="element-150" />
              Pagas en tu moneda local. El importe se adapta automáticamente a
              tu país.
            </p>
          </div>
        </motion.article>
      </div>
    </section>;
}
function PriceCard({
  label,
  name,
  desc,
  old,
  price,
  url,
  value
}: {
  label: string;
  name: string;
  desc: string;
  old: string;
  price: string;
  url: string;
  value: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="relative rounded-3xl border border-gold/60 bg-dark-card p-1" data-id="element-151">
      <span className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-gold px-5 py-1.5 text-xs font-bold text-black" data-id="element-152">
        {label}
      </span>

      <div className="rounded-[1.3rem] bg-black p-7 text-center sm:p-10" data-id="element-153">
        <h3 className="font-serif text-2xl font-bold text-gold-gradient" data-id="element-154">
          {name}
        </h3>
        <p className="my-5 text-gray-300" data-id="element-155">{desc}</p>
        <s className="text-gray-500" data-id="element-156">{old}</s>
        <p className="my-2 text-4xl font-bold text-gold" data-id="element-157">{price}</p>

        <Button target="_blank" href={url} onLinkClick={() => track(name, value)} className="mt-3 w-full sm:w-auto" data-id="element-158">
          QUIERO EL MEGA PACK
        </Button>

        <div className="mt-5 flex flex-wrap justify-center gap-4 text-xs text-gray-400" data-id="element-159">
          <span data-id="element-160">
            <Lock className="mr-1 inline text-gold" size={13} data-id="element-161" />
            Pago seguro
          </span>
          <span data-id="element-162">
            <Zap className="mr-1 inline text-gold" size={13} data-id="element-163" />
            Acceso inmediato
          </span>
          <span data-id="element-164">
            <Shield className="mr-1 inline text-gold" size={13} data-id="element-165" />
            Garantía 7 días
          </span>
        </div>
      </div>
    </motion.article>;
}